export const getCardBackgroundColor = (valorActual, valorEsperado) => {
  if (valorActual === 0 && valorEsperado === 0) return "transparent";

  if (valorEsperado > 0) {
    if (valorActual > valorEsperado) return "#ee7e7e"; // exceso
    if (valorActual > 0 && valorActual === valorEsperado) return "#86da89ff"; // completo
    if (valorActual > 0 && valorActual <= valorEsperado)
      return "rgb(255,217,102)"; // dentro del rango
    return "#fffffff2"; // sin acciones hasta el momento (default)
  }

  if (valorActual > 0 && valorEsperado === 0) return "rgb(237,125,49)"; // no esperado

  return "transparent";
};
